import { render, staticRenderFns } from "./DocumentPreviewTable.vue?vue&type=template&id=00a8ed5a&scoped=true&"
import script from "./DocumentPreviewTable.vue?vue&type=script&lang=ts&"
export * from "./DocumentPreviewTable.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPreviewTable.vue?vue&type=style&index=0&id=00a8ed5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a8ed5a",
  null
  
)

export default component.exports